import React from 'react'
// import head from './image/avatar.jpg'
// import github from './image/github.svg'
// import articles from './image/menu.svg'
// import me from './image/me.svg'
// import favorite from './image/favorite.svg'

import './Header.css'

const menus = () => (<div className="menus">
  <div className="tooltip">
    <a href="https://github.com/CassieLuoli">
      <img className="menus-item"
        src='./image/github.svg' alt="github"
      />
    </a>
    <span className="tooltiptext"
      tooltip-popup-delay="500"
    >My Github</span>
  </div>
  <div className="tooltip">
    <img className="menus-item"
      src='./image/menu.svg' alt="articles"
    />
    <span className="tooltiptext"
      tooltip-popup-delay="500"
    >My Articles</span>
  </div>
  <div className="tooltip">
    <img className="menus-item"
      src='./image/me.svg' alt="me"
    />
    <span className="tooltiptext"
      tooltip-popup-delay="500"
    >My Profile</span>
  </div>
  <div className="tooltip">
    <img className="menus-item"
      src='./image/favorite.svg' alt="favorite"
    />
    <span className="tooltiptext"
      tooltip-popup-delay="500"
    >My Favorite</span>
  </div>
</div>)

const footer = () => (
  <div className="footer">website in development</div>
)

export default () => (
  <header className="App-header">
    <div className="header-mask" >
      {
        menus()
      }
      <div className="header-main">
        <img src='./image/avatar.jpg'
          className="App-logo"
          alt="logo"
          width="100"
          height="100" />
        <h1 className="App-title">Lily Luo </h1>
        {/* <p className="App-subtitle">春眠不觉晓，处处闻啼鸟</p>*/}
        <div className="App-cover-divider" />
        <p className="App-desp">春眠不觉晓，处处闻啼鸟，总的有副标，样式才够好</p>
      </div>
      {
        footer()
      }
    </div>
  </header >
)



// WEBPACK FOOTER //
// ./src/head/Header.js